export const GET_PRESENCE_ENDPOINT = "/v1/presence/getpresence";
export const SET_WORK_LOCATION_ENDPOINT = "/v1/me/workLocation/";

export type ApiEndpoints = typeof GET_PRESENCE_ENDPOINT | typeof SET_WORK_LOCATION_ENDPOINT;
